/*
* This reducer file handle reducer's state for all actions that are related to jobs
*/
import _ from 'lodash';

const initialState = {
  items: [],
  isFetched: false,
  isFetching: true, // fetching list of jobs
  isUpdating: false, // updating a single job
  isImporting: false,
  isReimporting: false,
  simproUpdating: false,
  simproUpdated: false,
  importedJobId: null,
  isCreatingDocument: false,
  isUploadingFile: false,
  success: false,
  successMessage: '',
  companiesApi: null,
  reimportsuccess: false,
  failedStockAttachments: [],
  failedAttachments: [],
  check: 'import',
  ismanualSendingToSimpro: false,
  isOpenModalForError: false,
  createManualErrorType: '',
  moreEncryptedFiles: [],
  ismoreFilesClicked: false,
  simproAuthenticationFailed: false,
  manual_task_status: []
};

function onJobUpdateSuccess(state, action) {
  let items = _.clone(state.items);
  _.remove(items, { simpro_id: action.job.simpro_id });

  items.push(action.job);

  items.forEach((item) => {
    item.simpro_id = parseInt(item.simpro_id, 10);
  });

  items.sort((a, b) => {
    return a.simpro_id - b.simpro_id;
  });
  return Object.assign({}, state, {
    items: items,
    isUpdating: false,
    isImporting: false,
    isCreatingDocument: false,
    isUploadingFile: false,
    successMessage: ''

  });
}

export default function jobs(state = initialState, action) {
  switch (action.type) {
    case 'JOBS_FETCH_REQUEST':
      return Object.assign({}, state, {
        items: null,
        isFetching: true,
        isFetched: false,
        successMessage: ''
      });

    case 'JOBS_FETCH_SUCCESS':
      return Object.assign({}, state, {
        items: action.jobs,
        pagination: action.pagination,
        isFetching: false,
        isFetched: true,
        successMessage: ''
      });

    case 'JOBS_FETCH_FAILURE':
      return Object.assign({}, state, {
        items: null,
        isFetching: false,
        isFetched: true,
        error: action.error,
        errorMessage: action.message,
        successMessage: ''
      });

    case 'JOB_UPDATE_REQUEST':
      return Object.assign({}, state, {
        isUpdating: true,
        successMessage: ''
      });

    case 'JOB_UPDATE_SUCCESS':
      return Object.assign({}, state, onJobUpdateSuccess(state, action), {
        successMessage: 'Job Updated Successfully.'
      });
    case 'JOB_SUCCESSMSG_RESET':
      return Object.assign({}, state, {
        successMessage: ''
      });
    case 'JOB_FILE_UPLOAD_REQUEST':
      return Object.assign({}, state, {
        isUploadingFile: true,
        successMessage: ''
      });

    case 'JOB_FILE_UPLOAD_SUCCESS':
      return onJobUpdateSuccess(state, action);

    case 'JOBS_IMPORT_REQUEST':
    case 'JOBS_REFRESH_REQUEST':
      return Object.assign({}, state, {
        isImporting: true,
        importedJobId: null,
        successMessage: ''
      });

    case 'JOBS_IMPORT_SUCCESS':
      if (action.tokenStatus === 1) {
        window.localStorage.setItem('tokenStatus', action.tokenStatus);
        return Object.assign({}, state, {
          isImporting: false,
          success: false,
          tokenStatus: action.tokenStatus,
          companyData: action.companyData
        });
      }
      return Object.assign({}, state, onJobUpdateSuccess(state, action), {
        isImporting: false,
        importedJobId: '',//action.job.simpro_id,
        failedStockAttachments: action.job.failedStockAttachments,
        failedAttachments: action.job.failedAttachments,
        success: true
      });
    case 'JOB_POPUP_RESET':
      return Object.assign({}, state, {
        isCreatingDocument: false,
        isImporting: false,
        importedJobId: null,
        error: action.error,
        errorMessage: '',
        success: false
      });

    case 'JOB_CREATE_DOCUMENT_FAILURE':
      return Object.assign({}, state, {
        isCreatingDocument: false,
        isImporting: false,
        importedJobId: null,
        error: action.error,
        isOpenModalForError: true,
        errorMessage: '',
        createManualErrorType: action.errorType,
        createManualErrorFileName: action.errorFileName,
        mergeFiles: action.mergeFiles,
      });
    case 'JOBS_REFRESH_FAILURE':
    case 'JOBS_IMPORT_FAILURE':
      return Object.assign({}, state, {
        isCreatingDocument: false,
        isImporting: false,
        importedJobId: null,
        error: action.error,
        errorMessage: action.message,
      });
    case 'JOBS_REFRESH_SUCCESS':
      return Object.assign({}, onJobUpdateSuccess(state, action), {
        isImporting: false,
        importedJobId: action.job.simpro_id
      });

    case 'JOB_CREATE_DOCUMENT_REQUEST':
      return Object.assign({}, state, { isCreatingDocument: true, successMessage: '', isOpenModalForError: false, moreEncryptedFiles: [] });

    case 'JOB_CREATE_DOCUMENT_SUCCESS':
      return Object.assign({}, state, onJobUpdateSuccess(state, action), {
        successMessage: 'Manual created Successfully.',
        isCreatingDocument: false,
        isOpenModalForError: false
      });
    case 'JOB_STATUS_DOCUMENT_RESET':
      return Object.assign({}, state, { manual_task_status: [] });

    case 'JOB_STATUS_DOCUMENT_SUCCESS':
      console.log("action.job.status", action.job)
      return {
        ...state,
        manual_task_status: [...state.manual_task_status, action.job.status]
      };
    case 'JOB_STATUS_DOCUMENT_FAIL':
      return Object.assign({}, state, { manual_task_status: [] });

    case 'JOBS_DELETE_REQUEST':
      return Object.assign({}, state, {
        successMessage: ''
      });
    case 'JOBS_DELETE_SUCCESS':
      return Object.assign({}, state, {
        successMessage: 'Job Deleted Successfully.'
      });
    case 'COMPANIES_API_SUCCESS':
      return Object.assign({}, state, {
        companiesApi: action.apiAuthorize.companies
      });
    case 'JOBS_REIMPORT_REQUEST':
      return Object.assign({}, state, {
        isReimporting: true
      });
    case 'JOBS_REIMPORT_SUCCESS':
      if (action.tokenStatus === 1) {
        localStorage.setItem('tokenStatus', action.tokenStatus);
        return Object.assign({}, state, {
          isReimporting: false,
          reimportsuccess: false,
          tokenStatus: action.tokenStatus,
          companyData: action.companyData
        });
      }
      // console.log("failedfiles",action);
      return Object.assign({}, onJobUpdateSuccess(state, action), {
        isReimporting: false,
        reimportsuccess: true,
        importedJobId: '',//action.job.simpro_id,
        failedStockAttachments: action.job.failedStockAttachments,
        failedAttachments: action.job.failedAttachments,
        check: 'reimport'
      });
    case 'JOBS_REIMPORT_FAILURE':
      return Object.assign({}, state, {
        isReimporting: false,
        errorMessageForNotFound: 'Failed to Fetch job try to import'
      });
    case 'JOB_REIMPORT_POPUP_RESET':
      return Object.assign({}, state, {
        isCreatingDocument: false,
        isReimporting: false,
        importedJobId: null,
        error: action.error,
        errorMessage: '',
        reimportsuccess: false
      });
    case 'SEND_TO_SIMPRO_REQUEST':
      return Object.assign({}, state, {
        ismanualSendingToSimpro: true
      });
    case 'SEND_TO_SIMPRO_SUCCESS':
      if (action.tokenStatus === 1) {
        window.localStorage.setItem('tokenStatus', action.tokenStatus);
        return Object.assign({}, state, {
          ismanualSendingToSimpro: false,
          tokenStatus: action.tokenStatus,
          companyData: action.companyData
        });
      }
      return Object.assign({}, state, {
        ismanualSendingToSimpro: false
      });
    case 'SEND_TO_SIMPRO_FAILURE':
      return Object.assign({}, state, {
        ismanualSendingToSimpro: false
      });
    case 'CLOSE_MODAL_POPUP_FOR_ERROR':
      return Object.assign({}, state, {
        isOpenModalForError: false,
        createManualErrorType: '',
      });
    case 'FIND_ALL_ENCRYPTED_FILES_REQUEST':
      return Object.assign({}, state, {
        moreEncryptedFiles: [],
        ismoreFilesClicked: true
      });
    case 'FIND_ALL_ENCRYPTED_FILES_SUCCESS':
      return Object.assign({}, state, {
        moreEncryptedFiles: action.files.errorFiles,
        ismoreFilesClicked: false
      });
    case 'FIND_ALL_ENCRYPTED_FILES_FAILURE':
      return Object.assign({}, state, {
        ismoreFilesClicked: false
      });

    case 'SIMPRO_AUTHENTICATION_FAILED':
      return Object.assign({}, state, {
        simproAuthenticationFailed: !state.simproAuthenticationFailed,
        simproUpdated: false
      });

    case 'SIMPRO_UPDATE_DETAILS_REQUEST':
      return Object.assign({}, state, {
        simproUpdating: true
      });
    case 'SIMPRO_UPDATE_DETAILS_SUCCESS':
      return Object.assign({}, state, {
        simproUpdating: false,
        simproUpdated: true,
        errorMessage: "",
        simproAuthenticationFailed: false
      });
    case 'SIMPRO_UPDATE_DETAILS_FAILURE':
      // console.log(action);console.logconsole.log
      return Object.assign({}, state, {
        simproUpdating: false,
        simproUpdated: false,
        error: action.error,
        errorMessagesimpro: action.message,
      });
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/jobs.js